import { compact, isEqual, isObject } from "lodash";

const CREATE_BEZIER_TRANSITION = (
  opts = {
    duration: 0.4,
    delay: 0,
  },
) => ({
  ease: [0.19, 1, 0.22, 1],
  duration: opts.duration,
  delay: opts.delay,
});

function flattenArrayOfMultiselect(arr) {
  if (!arr || !Array.isArray(arr)) {
    return [];
  }

  return compact(
    compact(arr).map((item) => {
      if (isObject(item)) {
        if (item.value) {
          return item.value;
        }
        return undefined;
      }
      return item;
    }),
  );
}

function isUpdatedFromDefault(props) {
  if (!props) {
    return false;
  }
  if (!Array.isArray(props)) {
    return false;
  }
  if (props.length === 0) {
    return false;
  }

  return props.some((prop) => {
    if (!prop) {
      return false;
    }

    // if (!prop.hasOwnProperty("key")) {
    //   return false;
    // }

    // if (!prop.hasOwnProperty("default")) {
    //   return false;
    // }

    // If default is absent and prop is falsy
    if (!prop.hasOwnProperty("default") && (!prop.key || prop.key === "0")) {
      return false;
    }

    if (!isEqual(prop.key, prop.default)) {
      return true;
    }

    return false;
  });
}

// Determine whether the browser OS is mac
function isMac() {
  return navigator.platform.toUpperCase().indexOf("MAC") >= 0;
}

const IS_MAC = isMac();

function changeTransition(types, properties, transition, setProp) {
  // Types is array of type
  // Property is the property to change
  // Val is the value to change to
  var transtemp = {
    ...(transition ? transition : {}),
    types: {
      ...(transition?.types ? transition?.types : {}),
    },
  };

  types.forEach((type) => {
    transtemp.types[type] = {
      ...(transition?.types?.[type] ? transition?.types?.[type] : {}),
      ...properties,
    };
  });

  setProp((props) => {
    props.transition = transtemp;
  }, 300);
}

function typographyCSSRaw(typography, prefix) {
  // Loop through targets
  var css = "";
  for (var target in typography) {
    var targetCSS = "";
    var targetConfig = typography[target];

    if (targetConfig?.fontFamily) {
      targetCSS += `font-family: ${targetConfig.fontFamily};`;
    }

    if (targetConfig?.size) {
      targetCSS += `font-size: ${targetConfig.size};`;
    }

    if (targetConfig?.weight) {
      targetCSS += `font-weight: ${targetConfig.weight};`;
    }

    if (targetConfig?.lineHeight) {
      targetCSS += `line-height: ${targetConfig.lineHeight};`;
    }

    if (targetConfig?.letterSpacing) {
      targetCSS += `letter-spacing: ${targetConfig.letterSpacing};`;
    }

    // Word Spacing
    if (targetConfig?.wordSpacing) {
      targetCSS += `word-spacing: ${targetConfig.wordSpacing};`;
    }

    // Transform
    if (targetConfig?.transform) {
      targetCSS += `text-transform: ${targetConfig.transform};`;
    }

    // Text Decoration
    if (targetConfig?.decoration) {
      targetCSS += `text-decoration: ${targetConfig.decoration};`;
    }

    // Style
    if (targetConfig?.style) {
      targetCSS += `font-style: ${targetConfig.style};`;
    }

    // Color
    if (targetConfig?.color) {
      targetCSS += `color: ${targetConfig.color};`;
    }

    css += `${prefix ? prefix : ""}${target} {${targetCSS}}`;
  }
  return css;
}

const getDirectoryInfoFromParents = (parents, node) => {
  // Find the first directory parent
  const directoryParent = parents.find((parentId) => {
    const parentNode = node(parentId).get();
    return parentNode?.data?.custom?.slug === "grigora/directory";
  });

  if (!directoryParent) return null;

  const directoryNode = node(directoryParent).get();
  const directoryProps = directoryNode?.data?.props;

  if (!directoryProps?.selectedDirectoryType) return null;

  return {
    directoryTypeId: directoryProps.selectedDirectoryType,
  };
};

const getDirectoryFieldOptions = (
  directoryTypes,
  selectedDirectoryId,
  acceptableFieldTypes = ["text", "richtext", "datetime", "option"],
  includeCurrentDirectoryListing = false,
) => {
  if (!directoryTypes?.length || !selectedDirectoryId) {
    return [
      {
        label: "Select Field",
        value: "",
      },
    ];
  }

  const selectedDirectory = directoryTypes?.find(
    (type) => remove_prefix(type.sk, "directory-type-") === selectedDirectoryId,
  );

  if (!selectedDirectory?.fields) {
    return [
      {
        label: "Select Field",
        value: "",
      },
    ];
  }

  return [
    {
      label: "Select Field",
      value: "",
    },
    ...(includeCurrentDirectoryListing
      ? [
          {
            label: `Current ${selectedDirectory.name} Listing`,
            value: "current-listing",
          },
        ]
      : []),
    ...(selectedDirectory.fields?.flatMap((field) => {
      if (acceptableFieldTypes.includes(field.type)) {
        return [
          {
            label: field.label,
            value: field.id,
          },
        ];
      } else if (field.type === "reference") {
        // Find the referenced directory type
        const referencedType = directoryTypes?.find(
          (type) =>
            remove_prefix(type.sk, "directory-type-") === field.referenceTypeId,
        );

        // If found, add all its fields prefixed with the reference field name
        if (referencedType) {
          return [
            ...(includeCurrentDirectoryListing
              ? [
                  {
                    label: `Current ${selectedDirectory.name} > ${referencedType.name}`,
                    value: `${field.id}.current-listing`,
                  },
                ]
              : []),
            ...(referencedType.fields
              ?.filter((refField) =>
                acceptableFieldTypes.includes(refField.type),
              )
              ?.map((refField) => ({
                label: `${field.label} > ${refField.label}`,
                value: `${field.id}.${refField.id}`,
              })) ?? []),
          ];
        }
      }
      return [];
    }) ?? []),
  ];
};

function remove_prefix(string, prefix) {
  if (string) {
    return string.startsWith(prefix) ? string.slice(prefix.length) : string;
  }
  return "";
}

export {
  CREATE_BEZIER_TRANSITION,
  flattenArrayOfMultiselect,
  isMac,
  isUpdatedFromDefault,
  changeTransition,
  typographyCSSRaw,
  IS_MAC,
  getDirectoryInfoFromParents,
  getDirectoryFieldOptions,
  remove_prefix,
};
